// src/composables/useAnexoUpload.js
import { ref } from 'vue'
import { Api } from '@/funcoes/apiExport'

export function useAnexoUpload() {
    const isUploading = ref(false)
    const error = ref(null)
    const progress = ref(null) // opcional (fetch não dá progresso fácil)

    async function uploadAnexo({ docAnexo, file }) {
        error.value = null
        isUploading.value = true

        try {
            // 1) solicita a API gerar registro/URL
            const r = await Api.genericPost('/operacoes/solicitar/upload', docAnexo)
            if (r.bolok !== 1) throw new Error(r.erro || 'Falha ao solicitar upload')

            const idAnexo = r.id
            const uploadUrl = r.upload_url
            const method = r.upload_method || 'PUT'

            // 2) envia para o S3 (presigned)
            const resp = await fetch(uploadUrl, {
                method,
                body: file,
                headers: { 'Content-Type': file.type || 'application/octet-stream' },
            })

            if (!resp.ok) {
                const txt = await resp.text()
                console.error('Erro no upload S3', resp.status, txt)
                throw new Error('Falha ao enviar o arquivo para o armazenamento.')
            }

            const eTag = (resp.headers.get('etag') || '').replace(/"/g, '')

            // 3) confirma na API
            const rConf = await Api.genericPut('/cad/anexo', {
                id: idAnexo,
                fsize: file.size,
                fhash: eTag,
                storage_status: 1,
            })
            if (rConf.bolok !== 1) throw new Error(rConf.erro || 'Falha ao confirmar upload')


            return {
                id: idAnexo,
                etag: eTag,
                fname: file.name,
                fsize: file.size,
                mime: file.type,
            }
        } finally {
            isUploading.value = false
        }
    }

    return { isUploading, error, progress, uploadAnexo }
}
